module.exports = __webpack_public_path__ + "img/background.5b791c31.png";